export default __webpack_public_path__ + "static/media/skills-assessment.d2a1a626.svg";